import { Text } from '@wework/dieter-ui'
import * as _ from 'lodash'
// import { Space } from '@wework/floormap-sdk'
import React from 'react'
import changeCase from 'change-case'
import MetricDisplay from '../Common/MetricDisplay'
import Note from './Note'
import { CapacityIcon, NoteIcon } from '../Icons'
import NoteData from './NoteInformation'

interface Props {
  space: any
  BPO: boolean
  border: boolean
  containerStyle: {}
}
export default function ProductData({
  space,
  BPO = false,
  border = false,
  containerStyle = {},
}: Props) {
  if (!space || !space.reservable) {
    return null
  }

  const { inventoryData } = space
  if (!inventoryData) {
    return null
  }

  function getProductType() {
    let productType: string
    let type: string
    type = getType()
    if (
      space?.inventoryData &&
      space.inventoryData?.relationships?.length > 0
    ) {
      productType = space.inventoryData?.relationships[0]?.product_type
      type = changeCase.title(productType.replace('_', ' '))
    }
    return type
  }

  function getProductName() {
    let name: string
    name = space.reservable?.officeNumber
    if (
      space?.inventoryData &&
      space.inventoryData?.relationships?.length > 0
    ) {
      name = space.inventoryData?.relationships[0]?.name
    }
    return name
  }

  function getType() {
    const subType = space.subType?.toUpperCase()
    const programType = space.programType?.toUpperCase()
    let type = ''
    if (subType === 'PRIVATE OFFICE') {
      type = 'Office'
    } else if (programType === 'MEET') {
      type = 'Meeting Room'
    } else {
      type = changeCase.title(subType)
    }
    return type
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          paddingRight: '16px',
        }}
      >
        <div
          style={{
            border: '0',
            display: 'flex',
            padding: '16px 0',
          }}
        >
          <Text style={{ fontWeight: '700', fontSize: 12, width: 72 }}>
            Inventory
          </Text>
        </div>
        <div
          style={{
            border: '0',
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                border: '0',
                display: 'flex',
                alignItems: 'flex-start',
                paddingLeft: '16px',
                paddingTop: '16px',
              }}
            >
              <Text style={{ fontWeight: '400', fontSize: '16px' }}>
                {getProductName()}{' '}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: '400',
                  color: '#666666',
                  paddingLeft: 5,
                }}
              >
                {getProductType()}
              </Text>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: '16px',
                ...containerStyle,
              }}
            >
              <Text style={{ fontWeight: '400', fontSize: '14px' }}>
                {space.reservable?.displayPrice}
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          paddingRight: '16px',
          borderBottom: border ? '1px solid #E6E6E6' : 0,
        }}
      >
        <NoteData space={space} />
      </div>
    </>
  )
}
